import t from 'tcomb';

const Gender = t.enums.of(['M', 'F']);

module.exports = Gender;





/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Gender.js
 **/